<template>
	<div id="Main">
		<div v-if="!upload">
			<div class="box" v-for="(item,index) in list" :key="index">
				<p class="name">{{item[1]}}</p>
				<div class="content">
					<div class="item">
						<p class="title"><van-icon class="icon" :name="require('../../assets/images/service/details1.png')" />股权代码</p>
						<p class="data">{{item[0]}}</p>
					</div>
					<div class="item">
						<p class="title"><van-icon class="icon" :name="require('../../assets/images/service/details2.png')" />股权数量</p>
						<p class="data">{{item[2]}}</p>
					</div>
					<div class="item">
						<p class="title"><van-icon class="icon" :name="require('../../assets/images/service/details3.png')" />可用数量</p>
						<p class="data">{{item[3]}}</p>
					</div>
					<div class="item">
						<p class="title"><van-icon class="icon" :name="require('../../assets/images/service/details4.png')" />冻结数量</p>
						<p class="data">{{item[4]}}</p>
					</div>
				</div>
			</div>
			<div class="box" v-if="list.length>0">
				<p class="name">股权质押</p>
				<p class="warning">下列信息有 * 为必填项</p>
				<div class="form">
					<div class="inputbox"  @click="show=true">
						<div class="title">
							<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
							<span>企业简称</span>
						</div>
						<van-field class="input" readonly type="text" :value="currentindex<0?'':list[currentindex][1]" placeholder="请先选择企业简称" >
							<van-icon slot="button" class="select" name="play" />
						</van-field>
					</div>
					<div class="inputbox">
						<div class="title">
							<van-icon class="icon" :name="require('../../assets/images/service/account_1.png')" />
							<span>企业代码</span>
						</div>
						<van-field class="input" type="text" :value="currentindex<0?'':list[currentindex][0]" placeholder="请先选择企业简称"/>
					</div>
					<div class="inputbox">
						<div class="title">
							<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
							<span>质押数量</span><span class="ico">*</span>
						</div>
						<van-field class="input" @input="change" type="number" v-model="number" :placeholder="placeholder" />
					</div>
				</div>
			</div>
			<van-button round v-if="list.length>0" type="info" class="submit" @click="next()">下一步</van-button>
			<van-popup v-model="show" position="bottom" style="height: 40%">
				<van-picker :columns="columns" @cancel="show=false" @confirm="tab" :show-toolbar="true" />
			</van-popup>
		</div>
		<uploadimg v-if="upload" :type="4" @submit="submit"></uploadimg><!-- 上传图片组件 -->
		<div v-if="list.length==0 && isinitial">该账户没有可质押的股份！</div>
	</div>
</template>
<script>
	import uploadimg from '../../components/transfer';
	import axiosPost from '../../libs/moudle/index.js';
	export default {
		components: {
			uploadimg
		},
		data() {
			return {
				upload:false,
				show: false,
				columns: [],
				currentindex: -1,
				user: '',
				name: '',
				sharesdata: '',
				list:[],
				placeholder:'可用数量0',
				number:'',
				isinitial:false
			}
		},
		methods: {
			next(){
				if(this.number==''){
					this.$toast({duration:4000,message:'前填写必填项！'});
				}else{
					this.upload=true
				}
			},
			tab(value, index) { /* 下拉选择 */
				this.currentindex = index
				this.placeholder = '可用数量'
				this.placeholder += index < 0 ? '0' : this.list[index][3]
				this.show = false
				this.number = ''
			},
			change(e){/* 质押数量大小限制 */
				window.console.log(e)
				if(this.currentindex<0){
					this.$toast('请先选择企业代码！');
					this.number=''
				}else{
					if(e > (this.list[this.currentindex][3] * 1)){
						this.$toast({duration:4000,message:'质押数量不能超过可用最大数量！'});
						this.number=this.list[this.currentindex][3]
					}
					if(e <= 0){
						this.$toast({duration:4000,message:'质押数量不能为小0！'});
						this.number=1;
					}
				}
			},
			submit(e) {/* 质押提交 */
				window.console.log(e)
				let formdata={
					shareholdeCode:this.user,/* 股东代码 */
					shareholdeName:this.name,/* 股东姓名 */
					companyCode:this.list[this.currentindex][0],/* 企业代码 */
					companyShortName:this.list[this.currentindex][1],/* 企业简称 */
					pledgeNum:this.number,/* 质押数量 */
					img:e,/* 申请图片（注销登记通知书等） */
					bussinessType:4/* 类型 */
				}
				localStorage.setItem('formdata', JSON.stringify(formdata))
				this.$router.push({
					path: '/formdata'
				})
			},
			getdata() {
				let t=this;
				this.$toast.loading({
					message: '加载...',
					forbidClick: true,
					duration: 0
				});
				let params = '2907;' + this.user + ';;;;;;'
				axiosPost.getdata(params).then((res) => {
					this.isinitial=true;
					this.$toast.clear();
					if (res.data.filter && res.data.filter.msg) {
						this.$dialog.alert({
							title: '提示',
							message:res.data.filter.msg,
						}).then(() => {
							if (res.data.filter.code == 0) {
								share()
							}
						});
					}else{
						share()
					}
					function share(){
						let str = res.data.data
						if(res.data.code==200){
							let code = str.slice(0, str.indexOf(';'))
							if (code == 200) {
								str = str.slice(str.indexOf(';') + 1, str.indexOf('\r') - 3)
								t.sharesdata = str.split('\\n');
								
								t.sharesdata.forEach((val, index) => {
									t.sharesdata[index] = val.split(';');
									if(t.sharesdata[index][3]>0){
										t.columns.push(t.sharesdata[index][1])
										t.list.push(t.sharesdata[index])
									}
								});
								if (t.list.length == 0) {
									t.$toast({duration:4000,message:'该账户没有可质押的股份！'});
									return false;
								}
								window.console.log(t.sharesdata)
							} else if (code == 400) {
								t.$toast({duration:4000,message:'该账户没有托管股权！'});
							} else {
								t.$toast({duration:4000,message:str.slice(str.indexOf(';') + 1, str.indexOf('\r') - 3) + '，请稍后再试！'});
							}
						}else{
							t.$toast({duration:4000,message:res.data.msg});
						}
					}
					
				}).catch((res) => {
					window.console.log(res)
				})
			}
		},
		mounted() {
			this.user = this.$route.query.user
			this.name = this.$route.query.name
			this.getdata();
		}
	}
</script>

<style lang="scss" scoped>
	#Main {
		padding: 1.3rem;
		min-height: 100vh;
		background-color: #f2f9ff;

		.submit {
			width: 90%;
			display: block;
			margin: 2rem auto;
			background-color: #fa6b6b;
			border: 0;
			box-shadow: 0 3px 8px 1px #e8eaee;
		}

		.form {
			padding-bottom: 2rem;

			.inputbox {
				padding: 1rem 0;
				padding-left: 3rem;

				.input {
					flex: 1;
					padding: 0;
					height: 4rem;
					line-height: 4rem;
					border-bottom: 1px solid #e0dfdf;

					&:not(:last-child):after {
						display: none;
					}
				}

				.select {
					color: #a0a0a0;
				}
			}

			.title {
				text-align: left;
				line-height: 2.5rem;
				margin-left: -2.3rem;

				span {
					font-weight: bold;
					font-size: 1.6rem;
					color: #333;
				}

				.ico {
					color: #fa6b6b;
					display: inline-block;
					margin-left: 5px;
				}

				.icon {
					vertical-align: -0.25rem;
					margin-right: 0.8rem;
				}
			}
		}

		.box {
			background-color: #fff;
			border-radius: 8px;
			padding: 0 1rem;
			margin-bottom: 2rem;
			box-shadow: 0 2px 5px 1px #e4ebfa;

			.warning {
				font-size: 1.4rem;
				color: #fa6b6b;
				text-align: left;
				margin-bottom: 1rem;
			}

			.name {
				text-align: left;
				font-size: 1.8rem;
				color: #333;
				line-height: 3.5rem;
				padding-top: 0.6rem;
				font-weight: bold;
			}

			.content {
				display: flex;
				flex-wrap: wrap;

				.item {
					width: 50%;
					padding: 1rem 0;
					border-top: 1px solid #e0dfdf;
					font-size: 0;
					line-height: 2rem;

					&:nth-child(2n) {
						border-left: 1px solid #e0dfdf;
					}

					.title {
						font-size: 1.5rem;
						color: #8c8b8b;

						.icon {
							margin-right: 0.5rem;
							vertical-align: middle;
						}
					}

					.data {
						color: #333333;
						font-size: 1.6rem;
					}
				}
			}
		}
	}
</style>
